<template>
    <div id="validate-products-page">
        <div class="top">
            <h2>{{ trans('pages.validate_products.title') }}</h2>
            <ui5-button
                :disabled="disableSubmit"
                @click="validateProducts"
                :title="
                    selectedProductIds.size > 0
                        ? trans('pages.validate_products.validate_selected')
                        : trans('pages.validate_products.select_products')
                "
            >
                <spinner v-if="validating" />
                {{ trans('pages.validate_products.validate_selected') }}
            </ui5-button>
        </div>
        <div
            class="loader-spinner"
            v-if="loadingExportable"
        >
            <spinner-text>
                {{ trans('pages.validate_products.loading') }}
            </spinner-text>
        </div>
        <template v-else>
            <ul v-if="products">
                <li
                    v-for="product in products"
                    :key="'exportable.' + product.productId"
                    class="product-row"
                    @click="loadProductPage(product.productId)"
                >
                    <div class="checkbox-container">
                        <ui5-checkbox
                            id="toValidate"
                            :checked="selectedProductIds.has(product.productId)"
                            @click.stop
                            @change.stop="onProductSelect(product.productId)"
                        />
                    </div>
                    <div class="content">
                        <p class="title">
                            {{ product.productNr }} -
                            {{
                                product.name ||
                                trans(
                                    'pages.validate_products.no_product_reference'
                                )
                            }}
                        </p>
                        <p class="description">
                            {{ getProductDescription(product) }}
                        </p>
                    </div>
                </li>
            </ul>
        </template>
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import validateProductsApi from '../api/validateProducts';
import Spinner from '../components/loader/Spinner';
import { showErrorMessage } from '../dialogs';
import _ from 'lodash';
import { showConfirmDialog } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { Spinner, SpinnerText },
    mixins: [localization],
    data() {
        return {
            validating: false,
            loadingExportable: false,
            products: null,
            importing: false,
            progressList: [],
            resultList: [],
            selectedProductIds: new Set(),
            disableSubmit: true,
        };
    },
    computed: {
        uniqueResults() {
            return _.uniq(this.resultList, function (x) {
                return x.productId;
            });
        },
    },
    methods: {
        getProductDescription(product) {
            return (
                product.orderId +
                ' - ' +
                (product.reference ||
                    this.trans('pages.validate_products.no_order_reference'))
            );
        },
        loadProductPage(productId) {
            this.$router.push('/productpage/' + productId);
        },
        validateProducts() {
            showConfirmDialog({
                title: this.trans(
                    'pages.validate_products.confirm_dialog.title'
                ),
                content: this.trans(
                    'pages.validate_products.confirm_dialog.content'
                ),
                confirm: () => {
                    this.validating = true;
                    this.disableSubmit = true;
                    validateProductsApi
                        .validateProducts([...this.selectedProductIds])
                        .then((response) => {
                            // Refresh unvalidated products
                            this.products = response.data.data;
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans(
                                    'pages.validate_products.error_validate'
                                )
                            );
                        })
                        .finally(() => {
                            this.validating = false;
                            this.selectedProductIds = new Set();
                            this.disableSubmit = true;
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans(
                    'pages.validate_products.confirm_dialog.confirm'
                ),
                cancelButton: this.trans(
                    'pages.validate_products.confirm_dialog.cancel'
                ),
            });
        },
        loadExportableProducts() {
            this.loadingExportable = true;
            validateProductsApi
                .fetchExportableProducts()
                .then((response) => {
                    this.products = response.data.data;
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.validate_products.error_fetch')
                    );
                })
                .finally(() => {
                    this.loadingExportable = false;
                });
        },
        onProductSelect(productId) {
            this.selectedProductIds.has(productId)
                ? this.selectedProductIds.delete(productId)
                : this.selectedProductIds.add(productId);

            this.disableSubmit =
                this.validating || this.selectedProductIds.size === 0;
        },
    },
    mounted() {
        this.loadExportableProducts();
    },
};
</script>
